import Mirador from 'mirador/dist/es/src/index';
import TextOverlayPlugin from 'mirador-textoverlay/es';

function viewer(config, pluginsOrStruct) {
  let struct;

  if (!pluginsOrStruct) {
    struct = {
      plugins: []
    };
  } else if (Array.isArray(pluginsOrStruct)) {
    struct = { plugins: pluginsOrStruct };
  } else {
    struct = pluginsOrStruct;
    if (!Array.isArray(struct.plugins)) {
      struct.plugins = [];
    }
  }

  if (config.textOverlay) {
    struct.plugins = [...struct.plugins, ...TextOverlayPlugin];
  }

  return Mirador.viewer(config, struct);
}

const exports = {
  viewer
};

export default exports;
